import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import './BackButton.css';

const BackButton: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // The profile landing page is the home view and should not show a back control.
  if (location.pathname.startsWith('/profile/')) {
    return null;
  }

  const handleBack = () => {
    if (window.history.length > 1 && location.pathname !== '/browse') {
      navigate(-1);
      return;
    }

    navigate('/browse');
  };

  return (
    <button type="button" className="back-button" onClick={handleBack} aria-label="Go back">
      <FaArrowLeft aria-hidden="true" />
      <span>Back</span>
    </button>
  );
};

export default BackButton;

// Back navigation is intentionally rendered by Layout so every internal page gets the same control.
